import React from 'react';
import loadable from '@loadable/component';
import retry from '~/utils/retry';
import PopmenuLoading from '~/admin/shared/PopmenuLoading';

const SummaryStep = loadable(() => retry(() => import('./SummaryStep')), {
  fallback: <PopmenuLoading />,
});

export default SummaryStep;
